module.exports = __webpack_public_path__ + "static/media/join-title.500300bf.png";